'use client';

import { Box } from '@wishket/design-system';
import { PropsWithChildren } from 'react';
import { twJoin } from 'tailwind-merge';

import { useDeviceCheck } from '@/shared/hooks';

const AskAIBottomContainer = ({ children }: PropsWithChildren) => {
  const { isDesktop } = useDeviceCheck();

  const baseStyles = 'flex w-full items-start gap-4';
  const mobileStyles =
    'fixed bottom-0 left-0 right-0 border-t bg-w-white px-5 py-4 z-10';
  const desktopStyles =
    'desktop:relative desktop:border-t-0 desktop:bg-transparent desktop:p-0 desktop:justify-center';

  const containerStyles = isDesktop ? desktopStyles : mobileStyles;

  return <Box className={twJoin(baseStyles, containerStyles)}>{children}</Box>;
};

export default AskAIBottomContainer;
